import React from "react";
import { Link, useLocation } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

const getItemCount = (order) => {
  if (
    order.itemCount !== undefined &&
    order.itemCount !== null &&
    Number.isFinite(Number(order.itemCount))
  ) {
    return Number(order.itemCount);
  }
  if (!Array.isArray(order.items)) return null;
  return order.items.reduce((count, item) => {
    const quantity = Number(item.quantity);
    return count + (Number.isFinite(quantity) && quantity > 0 ? quantity : 1);
  }, 0);
};

const PaySuccess = () => {
  const location = useLocation();
  const state = location.state || {};
  const order = state.order || state;
  const {
    brandName,
    locale = "de-DE",
    currency = "EUR",
    contact = {},
  } = siteConfig;

  const orderNumber = order.orderNumber || order.reference || order.id;
  const rawConfirmationContact =
    order.email || order.contactEmail || order.customerEmail || order.contact;
  const confirmationContact =
    typeof rawConfirmationContact === "object"
      ? rawConfirmationContact?.email
      : rawConfirmationContact;
  const totalValue = order.total ?? order.amount ?? order.grandTotal;
  const numericTotal = Number(totalValue);
  const hasTotal =
    totalValue !== undefined && totalValue !== null && totalValue !== "";
  const formattedTotal =
    hasTotal && Number.isFinite(numericTotal)
      ? new Intl.NumberFormat(order.locale || locale, {
          style: "currency",
          currency: order.currency || currency,
        }).format(numericTotal)
      : null;
  const itemCount = getItemCount(order);
  const estimatedDelivery = order.estimatedDelivery || order.deliveryEstimate;

  return (
    <main className="pay-success">
      <section
        className="pay-success__confirmation"
        aria-labelledby="success-title"
      >
        <div className="pay-success__mark" aria-hidden="true">
          <svg viewBox="0 0 64 64" role="presentation">
            <path d="M18 33.5 27.5 43 47 22" />
          </svg>
        </div>
        <p className="pay-success__eyebrow">Bestellung erfolgreich</p>
        <h1 id="success-title">Danke, deine Bestellung ist bei uns.</h1>
        <p className="pay-success__lead">
          Wir bereiten deine Auswahl jetzt mit Sorgfalt vor. Sobald das Paket
          {brandName ? ` von ${brandName}` : ""} unterwegs ist, informieren wir
          dich.
        </p>

        {(orderNumber ||
          confirmationContact ||
          formattedTotal ||
          itemCount) && (
          <dl className="pay-success__order-meta" aria-label="Bestellübersicht">
            {orderNumber && (
              <div>
                <dt>Bestellnummer</dt>
                <dd>{orderNumber}</dd>
              </div>
            )}
            {itemCount !== null && (
              <div>
                <dt>Artikel</dt>
                <dd>{itemCount}</dd>
              </div>
            )}
            {formattedTotal && (
              <div>
                <dt>Gesamt</dt>
                <dd>{formattedTotal}</dd>
              </div>
            )}
            {confirmationContact && (
              <div>
                <dt>Bestätigung an</dt>
                <dd>{confirmationContact}</dd>
              </div>
            )}
          </dl>
        )}

        {!orderNumber &&
          !confirmationContact &&
          !formattedTotal &&
          itemCount === null && (
            <p className="pay-success__fallback-note">
              Deine Bestelldetails findest du in der Bestätigung, die wir dir
              nach Abschluss des Einkaufs senden.
            </p>
          )}

        <div className="pay-success__actions">
          <Link
            className="pay-success__button pay-success__button--primary"
            to="/shop"
          >
            Weiter einkaufen
          </Link>
          <Link
            className="pay-success__button pay-success__button--secondary"
            to="/"
          >
            Zur Startseite
          </Link>
        </div>
      </section>

      <section className="pay-success__next" aria-labelledby="next-title">
        <div className="pay-success__next-heading">
          <p className="pay-success__eyebrow">Wie geht es weiter?</p>
          <h2 id="next-title">Von der Bestellung bis zu deiner Tür</h2>
          {estimatedDelivery && (
            <p className="pay-success__estimate">
              Voraussichtliche Lieferung: <strong>{estimatedDelivery}</strong>
            </p>
          )}
        </div>
        <ol>
          <li>
            <span aria-hidden="true">01</span>
            <div>
              <h3>Bestätigung</h3>
              <p>Du erhältst eine Übersicht mit allen Bestelldetails.</p>
            </div>
          </li>
          <li>
            <span aria-hidden="true">02</span>
            <div>
              <h3>Sorgfältige Vorbereitung</h3>
              <p>Wir prüfen und verpacken deine Artikel passend zum Inhalt.</p>
            </div>
          </li>
          <li>
            <span aria-hidden="true">03</span>
            <div>
              <h3>Versand</h3>
              <p>
                Mit der Versandbestätigung erhältst du die Sendungsverfolgung.
              </p>
            </div>
          </li>
        </ol>
      </section>

      <aside className="pay-success__help" aria-labelledby="success-help-title">
        <div>
          <p className="pay-success__eyebrow">Noch eine Frage?</p>
          <h2 id="success-help-title">Unser Service hilft gerne.</h2>
          {contact.serviceHours && <p>{contact.serviceHours}</p>}
        </div>
        <div className="pay-success__help-links">
          {contact.email && (
            <a href={`mailto:${contact.email}`}>{contact.email}</a>
          )}

          <Link to="/contact">Zum Kontaktformular</Link>
        </div>
      </aside>
    </main>
  );
};

export default PaySuccess;
